/* eslint-disable @typescript-eslint/consistent-type-assertions */

import { DataBaseComponent } from "components/DataBaseComponent";
import { client, repository } from "clientInstance";
import octopusDynamicExtensions, { OctopusHttpRequestEvent, OctopusEventName, OctopusHttpResponseEvent, OctopusHttpErrorResponseEvent } from ".";
import loadjs from "loadjs";
import { ReactNode } from "react";
import { DynamicExtensionsScriptsResource } from "client/resources/dynamicExtensionsScriptsResource";
import { DynamicExtensionsFeaturesMetadataResource } from "client/resources/dynamicExtensionsFeaturesMetadataResource";

class DynamicExtensionsLoader extends DataBaseComponent<{}, {}> {
    componentDidMount() {
        // eslint-disable-next-line: no-floating-promises
        this.initialize();
    }

    render(): ReactNode {
        return null;
    }

    public async initialize() {
        try {
            const scripts = await repository.DynamicExtensions.getScripts();
            const metadata = await repository.DynamicExtensions.getFeaturesMetadata();
            await this.importOctopusDynamicExtensions(scripts, metadata);
        } catch (ex) {
            console.log(`Error loading Octopus dynamic extensions settings ${ex}`);
        }
    }

    private async importOctopusDynamicExtensions(scripts: DynamicExtensionsScriptsResource, metadata: DynamicExtensionsFeaturesMetadataResource) {
        try {
            if (!scripts.ConfigurationRetrieved) {
                return;
            }
            if (!window.hasOwnProperty("DynamicExtensions") && scripts.Scripts.length > 0) {
                octopusDynamicExtensions.setConfiguration(scripts, metadata);

                client.setOnRequestCallback((details) => {
                    const e = {
                        correlationId: details.correlationId,
                        method: details.method,
                        url: details.url,
                    };
                    octopusDynamicExtensions.publishEvent<OctopusHttpRequestEvent>(OctopusEventName.HttpRequest, e);
                });
                client.setOnResponseCallback((details) => {
                    const e = {
                        correlationId: details.correlationId,
                        method: details.method,
                        url: details.url,
                        statusCode: details.statusCode,
                    };
                    octopusDynamicExtensions.publishEvent<OctopusHttpResponseEvent>(OctopusEventName.HttpResponse, e);
                });
                client.setOnErrorResponseCallback((details) => {
                    const e = {
                        correlationId: details.correlationId,
                        method: details.method,
                        url: details.url,
                        statusCode: details.statusCode,
                        errorMessage: details.errorMessage,
                        errors: details.errors,
                    };
                    octopusDynamicExtensions.publishEvent<OctopusHttpErrorResponseEvent>(OctopusEventName.HttpErrorResponse, e);
                });

                scripts.Scripts.map((script) => {
                    loadjs([script.Url], "dynamicExtensions", {
                        success() {
                            console.log(`Finished loading ${script}`);
                        },
                        error(pathsNotFound) {
                            console.log(`Can't load ${pathsNotFound}`);
                        },
                        before(path, scriptEl) {
                            if (script.SriHash) {
                                ((scriptEl as unknown) as HTMLScriptElement).integrity = script.SriHash;
                                ((scriptEl as unknown) as HTMLScriptElement).crossOrigin = "anonymous";
                            }
                            return true;
                        },
                    });
                });

                //eslint-disable-next-line @typescript-eslint/no-explicit-any
                (window as any).DynamicExtensions = octopusDynamicExtensions.createScriptAdapter();
            }
        } catch (err) {
            // Silently fail.
            console.log("Octopus dynamic extensions failed to import", err);
        }
    }
}

export default DynamicExtensionsLoader;
